import React from "react";
import { useI18n } from "../context/LanguageContext";
import { LANGS } from "../i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Globe } from "lucide-react";

export function LanguageSelector() {
    const { mode, setLang } = useI18n();
    return (
        <Select value={mode} onValueChange={setLang}>
            <SelectTrigger data-testid="language-selector"
                className="h-8 w-[140px] bg-[#111827] border-[#1e293b] text-slate-200 text-sm">
                <Globe className="w-4 h-4 mr-1.5 text-slate-400 shrink-0" />
                <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#111827] border-[#1e293b] text-slate-100">
                {LANGS.map((l) => <SelectItem key={l.code} data-testid={`language-option-${l.code}`} value={l.code}>{l.label}</SelectItem>)}
            </SelectContent>
        </Select>
    );
}
